import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AppLocationFilter } from '../app/layout/AppLocationFilter';
import { ReactUIRouterView } from '../../uiMigration/ClientDashboardApp';
import { PageFilters } from '../app/layout/PageFilters';
import { Spinner } from '../../components';
import SessionStore from '../../services/session/SessionStore';
import { useState } from 'react';
import { getAllUsersAccounts } from '../../services/session/SessionApi';
import SelectedLocationsStore from '../../services/locations/SelectedLocationsStore';
import { stallUnresolvedPromises } from '../../util/async';
import { toJS } from 'mobx';
import { useObserver } from 'mobx-react-lite';
import { BindSelectedLocationsToUrl } from '../../services/locations/BindSelectedLocationsToUrl';
import EmailAlertsStringFilter from './EmailAlertsStringFilter';
import "./emailAlerts.scss";
import PageCommands from '../app/layout/PageCommands';
import { observer } from 'mobx-react';
import emailAlertsFiltersStore from './EmailAlertsFiltersStore';
import EmailAlertsUserFilter from './EmailAlertsUserFilter';

export default observer(function EmailAlertsPage(props) {

  const [state, setState] = useState({
    accounts: [],
    loading: true,
  });

  const fetchUpdate = stallUnresolvedPromises(async () => {
    const accounts = await getAllUsersAccounts();  
    return state => ({
      ...state,
      accounts,
      loading: false
    });
  });

  const fetchData = async () => {
    setState({
      ...state,
      loading: true,
    });
    fetchUpdate().then(setState);
  };

  const filters = useObserver(() => ({
    groupId: toJS(SelectedLocationsStore.legacyGroupIdOrAll),
    ...emailAlertsFiltersStore.state
  }));

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(toJS(filters))]);

  return (
    <React.Fragment>
      <PageFilters global={<AppLocationFilter />}>
        <EmailAlertsStringFilter />
        <EmailAlertsUserFilter />
      </PageFilters>
      <PageCommands>
        <a className="btn btn-secondary control-spacer-left nowrap" href="/#/emailAlerts/manage/add" requires-permission="CreateEmailAlerts">+ Add New Alert</a>
      </PageCommands>
      <BindSelectedLocationsToUrl />
      <div className="email-alerts-table">
        {!state.loading && SessionStore.sessionLoaded ? <ReactUIRouterView
          reactContainer={{
            accounts: state.accounts,
            loading: state.loading,
            setState,
            filters
          }}
          state={{
            template: require('../../../src/angularModules/emailAlerts/manage/manage.html'),
            controller: 'ManageEmailAlertsCtrl',
          }}
        /> : <Spinner timeout={0} size="xl" center />}
      </div>
    </React.Fragment>
  );
});